export { default as Config } from "./config.component";